import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { refundFormSchema } from './order-refund-form.schema';

export const useOrderRefundDrawerForm = context => {
  const form = useForm({
    resolver: yupResolver(refundFormSchema, context),
    defaultValues: refundFormSchema.cast({}),
  });

  return { form };
};
